import { Injectable, NgZone } from '@angular/core';
import {
  HttpClient, HttpParams, HttpHeaders
} from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ServiceBase } from './base.service';
import { User } from '../models/usuario.model';
import { AuthService } from './auth.service';
import { Data } from '../providers/data';
import { Observable } from 'rxjs';


@Injectable()
export class LoginService {
  constructor(
    public http: HttpClient,
    public serviceBase: ServiceBase,
    public authService: AuthService,
    public data: Data,


  ) {}

  login(email: string, passwd: string): Observable<any> {


    const urlService = this.serviceBase.getUrlApi('v1/auth');
    return this.http.post<any>(
      urlService,
        {
            email: email,
            password:  passwd,
        },
        this.serviceBase.postCommonHeaders()
    ).pipe(
        map((response) => this.mappUsuario(response) ),
        catchError(this.serviceBase.handleError)
    );


  }
  getUserSocial(email: string, tipoSocial: any, displayName: string, userIdApple: string = '0') {
    let urlService = this.serviceBase.getUrlApi('UsuarioTurno')
    return this.http.get<any>(urlService+ "v1/" + email + "/" + userIdApple +"/"+ tipoSocial + "/" + encodeURIComponent(displayName) )
    .pipe(
      map((response) => this.mappUsuario(response)  ),
      catchError(this.serviceBase.handleError)
    )

 }

  nuevoUsuario(usuario: User) {
    let urlService = this.serviceBase.getUrlApi('UsuarioTurno')
    return this.http.post<any>(urlService,
      {
        'Email': usuario.Email,
        'Contraseña': usuario.Password,
        'Nombre': usuario.Nombre,
        'Apellido': usuario.Apellido
      },
      this.serviceBase.postCommonHeaders()
    ).pipe(
      map((response) => response),
      catchError(this.serviceBase.handleError)
    )
  }

  olvideClaveStep1(email: string): any
  {
    const urlService = this.serviceBase.getUrlApi('v1/auth/forgotPassword/step1', [email]);
    return this.http.get<any>(urlService)
    .pipe(
      map((response) => response),
      catchError(this.serviceBase.handleError)
    );

  }
  olvideClaveStep2(email: string, token: string): any
  {
    const urlService = this.serviceBase.getUrlApi('v1/auth/forgotPassword/step2', [token, email]);
    return this.http.get<any>(urlService)
    .pipe(
      map((response) => response),
      catchError(this.serviceBase.handleError)
    );
  }

  olvideClaveStep3(token: string, password: string, email: string): any
  {
    const urlService = this.serviceBase.getUrlApi('v1/auth/forgotPassword/step3');
    return this.http
    .put<any>(urlService, {
      email: email,
      code: token,
      newPassword: password
    })
    .pipe(
      map(response => response),
      catchError(this.serviceBase.handleError)
    );
  }

  olvidePassword(email) {
    let urlService =
      this.serviceBase.getUrlApi('UsuarioEstablecimiento/OlvidePassword') +
      email;

    return this.http.get<any>(urlService).pipe(
      map(response => response),
      catchError(this.serviceBase.handleError)
    );
  }

  changePassword(actualPassword, newPassword) {
    let urlService = this.serviceBase.getUrlApi('v1/auth/changepassword');


    return this.http
      .put<any>(urlService, {
        actualPassword: actualPassword,
        newPassword: newPassword,
      })
      .pipe(
        map(response => response),
        catchError(this.serviceBase.handleError)
      );
  }

  resetPassword(token, email, newPassowrd, reenterPassword) {
    let urlService = this.serviceBase.getUrlApi(
      'UsuarioEstablecimiento/ResetPassword'
    );

    return this.http
      .put<any>(urlService, {
        token: token,
        email: email,
        newPassword: newPassowrd,
        reenterPassword: reenterPassword
      })
      .pipe(
        map(response => response),
        catchError(this.serviceBase.handleError)
      );
  }

  getPermisos() {
    /* return this.http.get('/assets/permisos.json').pipe(
      map((res: any) => this.data.setPermisos(res)),
      catchError(this.serviceBase.handleError)
    ); */
  }

  mappUsuario(response: any) {
    localStorage.setItem('userPrestador', JSON.stringify(response.user));
    localStorage.setItem('tokenPrestadorOcap', response.token);
  }
}
